export class CMS {
    brandName: string = "Health Perform";
    privacyLink: string = "";
    termsAndConditions: string = "";
    copyrightYear: number = 2019;
}
